import { gql } from '@apollo/client';

import { SKILL_FIELDS } from './skill.queries';

// Shared assignment selection: the list summarizes these, and the scoring page
// renders/scores them. Skill fields come from the shared SkillFields fragment.
const CALIBRATION_ASSIGNMENT_FIELDS = `
  _id
  companyId
  ageGroupBucket
  status
  assignedAt
  dueAt
  completedAt
  items {
    calibrationVideoId
    drillId
    skillId
    compositeScoreId
    completedAt
    calibrationVideo {
      _id
      filename
    }
    drill {
      _id
      name
    }
    skill {
      ...SkillFields
    }
  }
`;

// The caller's pending + completed calibration assignments, paged (offset/limit)
// so the list stays bounded as completed history accumulates.
export const GET_MY_CALIBRATION_ASSIGNMENTS = gql`
  query GetMyCalibrationAssignments($offset: Int, $limit: Int) {
    myCalibrationAssignments(offset: $offset, limit: $limit) {
      items {
        ${CALIBRATION_ASSIGNMENT_FIELDS}
      }
      total
    }
  }

  ${SKILL_FIELDS}
`;

// A single owned assignment by id — the scoring page / email deep link loads one
// without paging the whole list.
export const GET_CALIBRATION_ASSIGNMENT = gql`
  query GetCalibrationAssignment($_id: ID!) {
    calibrationAssignment(_id: $_id) {
      ${CALIBRATION_ASSIGNMENT_FIELDS}
    }
  }

  ${SKILL_FIELDS}
`;

// Just the caller's pending count — cheap enough (no item enrichment) to poll on a short
// interval for the in-app assignment badge and the throttled completion prompt.
export const GET_CALIBRATION_ASSIGNMENT_SUMMARY = gql`
  query GetCalibrationAssignmentSummary {
    calibrationAssignmentSummary {
      pendingCount
    }
  }
`;
